/* global runtime, multiClientStore, subscribeBusinessState, publishGlobals, activeBusinessKey, localStorage, window */
// ============================================================
// KLIENTFANER — å lukke en åpen klient
// ============================================================
// Byråflaten holder flere klienter åpne som faner (se multiClientStore.js). Å lukke
// en fane er mer enn å slette en plass i lageret: lytteren må rives ned, og er det
// fanen brukeren står i, må appen slippe den aktive klienten.
//
// Den aktive klienten KAN lukkes. Det var den ikke før, og resultatet var en fane
// man ikke ble kvitt: hadde man én klient åpen, satt den til neste innlogging.
// Appen tåler å stå uten aktivt regnskap — byråflaten faller da tilbake til
// klientoversikten, som leser byrået og ikke en enkelt klients state, og det er
// samme tilstand en byråbruker uten eget foretak logger inn i.
//
// Ligger her, og ikke i backend.jsx, fordi fasaden er stor nok fra før.

const releaseClient = (businessId) => {
  if (!multiClientStore || !businessId) return false;
  const wasActive = businessId === runtime.activeBusinessId;
  const slot = multiClientStore.closeClient(businessId);
  if (!slot) return false;
  if (wasActive) {
    // Den aktive klientens lytter ER `runtime.unsubscribeState`, og
    // `subscribeBusinessState` river den ned. Nulles den ikke her, rives den to
    // ganger — plassen holder den samme funksjonen.
    slot.unsubscribe = null;
    runtime.activeBusinessId = null;
    // Uten dette ville neste innlogging åpnet klienten man nettopp lukket.
    if (runtime.user) localStorage.removeItem(activeBusinessKey(runtime.user.uid));
    subscribeBusinessState();
    publishGlobals(runtime.appState);
  }
  if (typeof slot.unsubscribe === 'function') slot.unsubscribe();
  // Merk at `runtime.saveTimer` IKKE røres. Den bærer en ulagret endring med sin
  // egen businessId inn i lukkingen, og skal få lagre ferdig etter at fanen er
  // borte. `slot.saveTimer` hører til en parkert fane og har ingen slik jobb.
  if (slot.saveTimer) window.clearTimeout(slot.saveTimer);
  return true;
};

// ============================================================
// KLIENTPLASSER — parkere, hente tilbake og slippe klienter
// ============================================================
// Flyttet hit fra backend-state-access.jsx, som er over storrelsesgrensen. Brukes
// av bytte-stien og utloggingen i backend.jsx og av subscribeBusinessState.

// Legger den aktive klientens state til side for den er byttet bort fra.
const parkActiveClientState = () => {
  if (!multiClientStore || !runtime.activeBusinessId) return;
  const slot = multiClientStore.openClient(runtime.activeBusinessId);
  if (!slot) return;
  slot.appState = runtime.appState;
  slot.appStateRevision = runtime.appStateRevision;
  slot.persistedAppStateRevision = runtime.persistedAppStateRevision;
  slot.persistedShardRevisions = runtime.persistedShardRevisions;
  slot.personnelStateReadable = runtime.personnelStateReadable;
  slot.unsubscribe = runtime.unsubscribeState;
  slot.error = runtime.error;
  slot.loading = runtime.loading;
};

// Henter en tidligere apen klient tilbake. Returnerer true bare nar bade staten og
// en levende lytter finnes — ellers ma den lastes pa nytt pa vanlig mate.
const restoreClientState = (businessId) => {
  if (!multiClientStore) return false;
  const slot = multiClientStore.getSlot(businessId);
  if (!slot || !slot.appState || typeof slot.unsubscribe !== 'function') return false;
  runtime.appState = slot.appState;
  runtime.appStateRevision = slot.appStateRevision || '';
  runtime.persistedAppStateRevision = slot.persistedAppStateRevision || '';
  runtime.persistedShardRevisions = slot.persistedShardRevisions || {};
  runtime.personnelStateReadable = slot.personnelStateReadable;
  runtime.unsubscribeState = slot.unsubscribe;
  runtime.loading = false;
  runtime.error = slot.error || null;
  multiClientStore.setActive(businessId);
  return true;
};

// Et tak pa antall apne klienter. Hver av dem holder et helt regnskap i minnet og en
// Firestore-lytter, sa en lang arbeidsdag med fanebytter ma ikke fa vokse fritt.
const releaseOverflowClients = () => {
  if (!multiClientStore) return;
  multiClientStore.evictOverflow().forEach((slot) => {
    if (typeof slot.unsubscribe === 'function') slot.unsubscribe();
    if (slot.saveTimer) window.clearTimeout(slot.saveTimer);
  });
};

const releaseAllClients = () => {
  if (!multiClientStore) return;
  multiClientStore.closeAll().forEach((slot) => {
    if (typeof slot.unsubscribe === 'function') slot.unsubscribe();
    if (slot.saveTimer) window.clearTimeout(slot.saveTimer);
  });
};
